import { TypeUtils } from '../../framework/utils/UtilityTypes';
import { Formatter } from './FormatUtils';

const isValidEmail = (email?: string) =>
  !TypeUtils.isNilString(email) &&
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
    email
  );
const isZenkakuKatakana = (name?: string) =>
  !TypeUtils.isNilString(name) && /^[ァ-ヶー　]*$/.test(name);
const lessThan = (lower: number | string, upper: number | string) => {
  const l = typeof lower === 'string' ? parseInt(lower, 10) : lower;
  const u = typeof upper === 'string' ? parseInt(upper, 10) : upper;
  return l <= u;
};

const lessThanDate = (from?: string, to?: string) => {
  const f = Formatter.createDate(from || '');
  const t = Formatter.createDate(to || '');
  return f <= t;
};

export const Validator = {
  isValidEmail,
  isZenkakuKatakana,
  lessThan,
  lessThanDate,
};
